// Convert API error responses (DRF and our custom { error: ... } shape) into a
// human-readable string suitable for a toast.

const FIELD_LABELS = {
    category_id: 'Caste Category',
    privilege_category_id: 'Privilege Category',
    academic_year_id: 'Academic Year (Year of Joining)',
    contact_numbers: 'Contact Numbers',
    addresses: 'Address',
    first_name: 'First Name',
    middle_name: 'Middle Name',
    last_name: 'Last Name',
    date_of_birth: 'Date of Birth',
    father_name: "Father's Name",
    mother_name: "Mother's Name",
    permanent_registration_number: 'Permanent Registration Number',
    registration_number: 'Registration Number',
    profile_picture: 'Profile Picture',
    email: 'Email',
    blood_group: 'Blood Group',
    gender: 'Gender',
    nationality: 'Nationality',
    religion: 'Religion',
    other_religion: 'Religion',
    sub_category: 'Sub Category',
    disability_type: 'Disability Type',
    disability_percent: 'Disability Percent',
    ews_annual_family_income: 'Annual Family Income',
    pincode: 'Pin Code',
    city_id: 'City',
    state_id: 'State',
    country_id: 'Country',
    address: 'Address',
    address_type: 'Address Type',
    contact_type: 'Contact Type',
    country_code: 'Country Code',
    number: 'Phone Number',
    is_primary: 'Primary Contact',
    lag: 'Class',
    academic_year: 'Academic Year (Year of Joining)',
    qualifying_subjects: 'Subjects',
    subject: 'Subject',
    course_name: 'Class / Course Name',
    qualification_type: 'Qualification Type',
    board: 'Board',
    college: 'School / College',
    year_of_admission: 'Year of Admission',
    year_of_passing: 'Year of Passing',
    percentage: 'Percentage',
    qualification_status: 'Qualification Status',
    qualification_stream: 'Qualification Stream',
    maximum_marks: 'Maximum Marks',
    marks_obtained: 'Marks Obtained',
    roll_number: 'Roll Number',
    student_division: 'Division',
};

const humanizeFieldName = (key) => {
    if (FIELD_LABELS[key]) return FIELD_LABELS[key];
    return String(key)
        .replace(/_id$/, '')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

const friendlyMessage = (raw) => {
    if (typeof raw !== 'string') return String(raw);
    let msg = raw.trim();
    // DRF "Invalid pk \"X\" - object does not exist."
    if (/^Invalid pk\b/i.test(msg)) return 'Please select a valid value.';
    // DRF "This field is required." / "This field may not be blank."
    if (/^This field is required\.?$/i.test(msg)) return 'This field is required.';
    if (/^This field may not be blank\.?$/i.test(msg)) return 'This field cannot be blank.';
    if (/^This field may not be null\.?$/i.test(msg)) return 'This field is required.';
    return msg;
};

const flattenErrorValue = (val) => {
    if (val === null || val === undefined) return [];
    if (typeof val === 'string') return [friendlyMessage(val)];
    if (Array.isArray(val)) return val.flatMap(flattenErrorValue);
    if (typeof val === 'object') {
        return Object.entries(val).flatMap(([k, v]) => {
            const inner = flattenErrorValue(v);
            return inner.map((m) => `${humanizeFieldName(k)}: ${m}`);
        });
    }
    return [String(val)];
};

export const formatApiError = (response, fallback = 'Save failed') => {
    if (!response) return fallback;
    if (typeof response === 'string') return friendlyMessage(response) || fallback;

    // Our custom shape: { error: "string" } or { error: { field: [...] } }
    if (response.error !== undefined) {
        const messages = flattenErrorValue(response.error);
        if (messages.length) return messages.join(' | ');
    }

    // DRF generic detail
    if (response.detail) {
        return friendlyMessage(String(response.detail));
    }

    // DRF field errors at the top level: { field: ["msg"], ... }
    const messages = flattenErrorValue(response);
    if (messages.length) return messages.join(' | ');

    return fallback;
};

export default formatApiError;
